import Vue from 'vue';

const translate = function (word, params) {
    // TODO: сделать много параметров
    const newVue = new Vue()

    // params.forEach((param, index) => {
    // 	console.log('param', param)
    // 	translate += newVue.$ml.with(`v${index}`, param)
    // })

    try {
        const defaultTranslate = newVue.$ml.get(word)
        if (params) {
            if (defaultTranslate) {
                if (params.length === 1) return newVue.$ml.with('v1', params[0]).get(word)
                if (params.length === 2) return newVue.$ml.with('v1', params[0]).with('v2', params[1]).get(word)
            } else {
                const engIndexInList = newVue.$ml.list.findIndex(item => item === 'en')
                let phrase = newVue.$ml.db[engIndexInList][word]
                if (params[0]) phrase = phrase.replace('{v1}', params[0])
                if (params[1]) phrase = phrase.replace('{v2}', params[1])
                return phrase
            }
        } else {
            if (defaultTranslate) {
                return defaultTranslate
            } else {
                const engIndexInList = newVue.$ml.list.findIndex(item => item === 'en')
                if (engIndexInList) {
                    return newVue.$ml.db[engIndexInList][word]
                } else {
                    return word
                }
            }
        }
    } catch (ex) {
        return word
    }
}

Vue.prototype.translate = translate
export default translate